/**
 * Pasos para exportar un crucigrama
 * 1. Generar el crucigrama en https://www.educima.com/crosswordgenerator.php
 * 2. En la página que se abre, copiar del DOM el elemento con id="crossword"
 * 3. Reemplazar en el elemento los siguientes atributos
 * 3.1 Reemplazar 'class' por 'className'
 * 3.2 Ajustar el 'style' en react 'style={{ textAlign: 'center' }}'
 * 3.3 Reemplazar 'maxlength="1"' por 'maxLength={1} onKeyDown={handleOnKeyDown}'
 */

import { handleOnKeyDown } from 'utils/crosswords.utils';

export const Crossword1 = (
    <div className="center crossword col-md-12" id="crossword" style={{ textAlign: 'center' }}>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    placeholder=""
                />
                <span className="num">1</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    placeholder=""
                />
                <span className="num">2</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num">3</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num">4</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    placeholder=""
                />
                <span className="num">5</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="W"
                    placeholder=""
                />
                <span className="num">6</span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    placeholder=""
                />
                <span className="num">7</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="V"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num">8</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="X"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    placeholder=""
                />
                <span className="num">9</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num">10</span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="M"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="P"
                    placeholder=""
                />
                <span className="num">11</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num">12</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="B"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    placeholder=""
                />
                <span className="num">13</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="U"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="O"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="S"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="T"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num">14</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="L"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="F"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="R"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num">15</span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="D"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="I"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="C"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="E"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="A"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square">
                <input
                    type="text"
                    className="char"
                    maxLength={1}
                    onKeyDown={handleOnKeyDown}
                    data-letter="N"
                    placeholder=""
                />
                <span className="num"></span>
            </div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
        <div className="row">
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
            <div className="square"></div>
        </div>
    </div>
);
